
require("./page.scss");

import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import InfiniteScroll from "infinite-scroll";

(function ($) {


    let grid = document.querySelector('.section-custom-view__');

    var msnry = new Masonry(grid, {
        // options
        itemSelector: '.wp-block-custom-figure-block, .wp-block-video',
        // columnWidth: '.wp-block-custom-figure-block',

    });

    if (typeof objects !== "undefined") {
        if (objects.infiniteScroll === "true") {

            InfiniteScroll.imagesLoaded = imagesLoaded;

            let infScroll = new InfiniteScroll('.section-custom-view__', {
                // Infinite Scroll options...
                path: getPenPath,
                append: '.wp-block-custom-figure-block, .wp-block-video',
                outlayer: msnry,
                history: false,
                checkLastPage: true,
                status: '.page-load-status',
            });


            window.addEventListener('scroll', function () { /*console.log(this.scrollY)*/ })

            if ($('.main').height() > $(window).height()) {
                // console.log($('.main').height());
            } else {
                $('.main').css('min-height', $(window).height() + 2);
                console.log($('.main').height());
            }

        }
    }




    function getPenPath() {

        const nextPenSlugs = [];

        for (let i = parseInt(pages.index); i <= pages.total; i++) {
            nextPenSlugs.push('/' + pages.parent + '/page-' + i)
        }

        let slug = nextPenSlugs[this.loadCount];    
        if (slug) return `${slug}`;
    }

    // $(".wp-block-video").css("display","none");
    $(window).load(function(){
        // $(".wp-block-video").css("display","block");
        msnry.layout();
    });


})(jQuery)

